import { Routes, Route, useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import { useEffect } from 'react';

import './App.css';


import ProtectedRoute from './lib/ProtectedRoute.js';
import Layout from './components/layout/Layout';

import Home from './pages/Home.jsx';
import Resource from './pages/Resource.jsx';
import Blog from './pages/Blog.jsx'
import Contact from './pages/Contact.jsx';
import About from './pages/About.jsx';
import Privacy from './pages/Privacy.jsx';

import Profile from './pages/user/Profile.jsx';
import Auth from './pages/user/Auth.jsx';

import NetworkAccess from './pages/networking/NetworkAccess.jsx';
import NetworkAddressing from './pages/networking/NetworkAddressing.jsx';
import NetworkAutomation from './pages/networking/NetworkAutomation.jsx';
import NetworkConnectivity from './pages/networking/NetworkConnectivity.jsx';
import NetworkFundamentals from './pages/networking/NetworkFundamentals.jsx';
import NetworkServices from './pages/networking/NetworkServices.jsx';

import CloudRunDeploy from './pages/cloud/CloudRunDeploy.jsx';

import FileConverter from './pages/tools/FileConverter.jsx';
import FileCompress from './pages/tools/FileCompress.jsx';

import VideoEditors from './pages/review/VideoEditors.jsx';
import SmartPhones from './pages/review/SmartPhones.jsx';

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search});
  }, [location]);

  return null;
}

function App() {

  return (
    <>
      <AnalyticsTracker />
      <Routes>

        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/resource" element={<Resource />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />

                  {/* Authenticaton */}
          <Route path="/user/Profile" element={<ProtectedRoute> <Profile /> </ProtectedRoute>} />
          <Route path="/user/Auth" element={<Auth />} />


                  {/* Networking Pages */}
          <Route path="/networking/fundamentals" element={<ProtectedRoute><NetworkFundamentals /></ProtectedRoute>} />
          <Route path="/networking/addressing" element={<ProtectedRoute><NetworkAddressing /></ProtectedRoute>} />
          <Route path="/networking/access" element={<ProtectedRoute><NetworkAccess /></ProtectedRoute>} />
          <Route path="/networking/connectivity" element={<ProtectedRoute><NetworkConnectivity /></ProtectedRoute>} />
          <Route path="/networking/automation" element={<ProtectedRoute><NetworkAutomation /></ProtectedRoute>} />
          <Route path="/networking/services" element={<ProtectedRoute><NetworkServices /></ProtectedRoute>} />

                  {/*Cloud Technology */}
          <Route path="/cloud/CloudRunDeploy" element={<ProtectedRoute><CloudRunDeploy /></ProtectedRoute>} />

                  {/*Tools */}
          <Route path="/tools/FileConverter" element={<ProtectedRoute><FileConverter /></ProtectedRoute>} />
          <Route path="/tools/FileCompress" element={<ProtectedRoute><FileCompress /></ProtectedRoute>} />

                    {/* Review Pages */}
          <Route path="/review/VideoEditors" element={<VideoEditors />} />
          <Route path="/review/SmartPhones" element={<SmartPhones />} />



        </Route>
      </Routes>
    </>
  );
}

export default App;
